<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="2" v-if="!isReadOnly">
                    <b-form-group class="mb-0">
                        <label class="d-none d-md-block">&nbsp;</label>
                        <b-button variant="primary" block @click="save">
                            {{ $t('save').toUpperCase() }}
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>

<script>
import StudentRequestService from '@/services/StudentRequestService';
import { EventBus } from "@/main";

export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
        isReadOnly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            formLoading: false,
        };
    },
    computed: {
        getReservationToken() {
            return this.$store.getters['roomReservationSystem/getReservationToken'];
        },
    },
    methods: {
        async save() {
            this.formLoading = true;
                const config = {
                };

                const formData = {request_type: 'fob_replacement',
                    housing_reservation_id: this.data.id

                };


                try {
                    const response = await StudentRequestService.studentRequest(formData, config);
                    this.$toast.success(this.$t('api.' + response.data.message));
                    this.$router.push('/housing/request/list');
                } catch (error) {
                    EventBus.$emit('formClearRequest');
                    this.showErrors(error, this.$refs.formModalValidate);
                } finally {
                    this.formLoading = false;
                }
        },
    },
};
</script>
